import React from "react";
import Layout from "../../components/Layout";

const PaymentSuccessPage = () => {
	return (
		<Layout>
		<div className="min-h-screen bg-[#f5f3ee] flex items-center justify-center px-4">
		<div className="bg-white shadow-2xl rounded-2xl max-w-xl w-full p-8 text-center">
		
		<div className="flex flex-col items-center">
		<svg
		className="w-16 h-16 text-green-500 mb-4"
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		>
		<path
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeWidth={2}
		d="M5 13l4 4L19 7"
		/>
		</svg>
		
		<h2 className="text-2xl font-bold text-gray-900 mb-2">Ödəniş Uğurla Tamamlandı!</h2>
		<p className="text-gray-700 text-sm sm:text-base leading-relaxed">
		Biletiniz e-mail ünvanınıza göndərildi. Zəhmət olmasa <strong>inbox</strong> və <strong>spam</strong> qovluğunuzu yoxlayın. <br />
		Əgər hər hansı səbəbdən bilet sizə çatmayıbsa, zəhmət olmasa <strong className="text-black">+994556611161</strong> nömrəsi ilə əlaqə saxlayın.
		</p>
		
		<a href="/" className="mt-6 inline-block bg-black text-white font-semibold px-6 py-3 rounded-lg hover:bg-gray-800 transition-all">
		Ana səhifəyə qayıt
		</a>
		</div>
		</div>
		</div>
		
		</Layout>
	);
};

export default PaymentSuccessPage;
